import gql from "graphql-tag";

export default gql`
  query {
    siloLocations {
      id
      name
      capacity
      monitorSensor {
        id
        unit
        materialType
        lastMeasurement
      }
    }
  }
`;
